import { FC } from "react";
import { useOrgId } from "@src/common/reliablePartnerApi";
import { useAppSelector } from "@src/reduxStore";

export interface LinkToCompanyInvoicingDetailsProps {
  orgId?: string;
}

const LinkToCompanyInvoicingDetails: FC<LinkToCompanyInvoicingDetailsProps> = ({
  children,
  orgId,
}) => {
  const config = useAppSelector(state => state.common.config);
  const currentOrgId = useOrgId();
  const urlOrgId = orgId || currentOrgId;

  return (
    <a
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      href={`${config?.companiesUrl}/#/${urlOrgId}/organization/invoicingdetails`}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  );
};

export default LinkToCompanyInvoicingDetails;
